import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { store } from 'store/store'
import css from './Tele2Button.module.scss'

export const Tele2Button = observer(() => {
  const { cart_link, item_link } = store.basic

  const onCart = useLatestCallback(() => {
    controller.openTele2Qr()
  })

  if (!cart_link && !item_link) return null

  return <Space className={css.cart} center onClick={onCart}>
    <Typo size={24} semi upper>
      {cart_link ? i18n('tele2.AddToCart') : i18n('tele2.OpenShop')}
    </Typo>
  </Space>
})
